module.exports = __webpack_public_path__ + "img/letter_top.222f6ac2.png";